import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { OpenInBrowser } from '@mui/icons-material'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  useStartSpreadsheet,
  useStudyGet,
} from '../../../APIs/Hooks/StudyHooks'

function ExportFormatField({
  rowId,
  selectedId,
  animals,
  anchorEl,
  setAnchorEl,
  source,
}: {
  rowId: string
  selectedId: string
  animals: any
  anchorEl: any
  setAnchorEl: any
  source: string
}) {
  const navigate = useNavigate()
  const { data: formats } = useStudyGet('/metadata/export_formats')
  const { mutate: startSpreadsheet } = useStartSpreadsheet(rowId, animals, {
    onSuccess: (data) => {
      navigate(`/stuart/study/${rowId}/export?id=${data.data_collection_id}`, {
        state: { source: source },
      })
    },
  })

  return (
    <Menu
      anchorEl={anchorEl}
      open={!!anchorEl && rowId === selectedId}
      onClose={() => {
        setAnchorEl(null)
      }}
      sx={{ maxWidth: '300px' }}
    >
      {formats &&
        formats.map((f: any, i: any) => (
          <MenuItem
            key={i}
            onClick={() => {
              setAnchorEl(null)
              startSpreadsheet(f.id)
            }}
          >
            <ListItemIcon>
              <OpenInBrowser fontSize="small" />
            </ListItemIcon>
            <ListItemText>{f.Name}</ListItemText>
          </MenuItem>
        ))}
    </Menu>
  )
}

export default ExportFormatField
